import { z } from "@/zod";

export const storeId = z.string().length(26);
